/**
 * Standalone copy of `sizeToSqft` (also exported from store.js) — kept
 * here so unit tests can import it without dragging in axios. The two
 * must stay byte-identical; if you change one, change both.
 */
export const sizeToSqft = (sizeStr, category) => {
  if (!sizeStr) return 0;
  const s = String(sizeStr).toLowerCase().trim();

  const TO_FEET = { ft: 1, feet: 1, in: 1 / 12, inch: 1 / 12, inches: 1 / 12, cm: 1 / 30.48, mm: 1 / 304.8, m: 3.28084, meter: 3.28084, meters: 3.28084 };
  const sideRe = /(\d+(?:\.\d+)?)\s*(ft|feet|in|inch|inches|cm|mm|m|meter|meters)\b/g;
  const sides = [...s.matchAll(sideRe)];
  if (sides.length === 2) {
    const a = parseFloat(sides[0][1]) * TO_FEET[sides[0][2]];
    const b = parseFloat(sides[1][1]) * TO_FEET[sides[1][2]];
    if (!isNaN(a) && !isNaN(b) && a > 0 && b > 0) return a * b;
  }

  let unit = null;
  const mUnit = s.match(/\b(ft|feet|in|inch|inches|cm|mm)\b\s*$/);
  if (mUnit) {
    const u = mUnit[1];
    unit = (u === 'feet') ? 'ft' : (u === 'inch' || u === 'inches') ? 'in' : u;
  }
  const cleaned = unit ? s.replace(mUnit[0], '').trim() : s;
  const parts = cleaned.split(/[x×]/).map(p => parseFloat(p.replace(/[^\d.]/g, '')));
  if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return 0;
  const a = parts[0], b = parts[1];
  const raw = a * b;

  if (unit === 'ft') return raw;
  if (unit === 'in') return raw / 144;
  if (unit === 'cm') return raw / (30.48 * 30.48);
  if (unit === 'mm') return raw / (304.8 * 304.8);
  if (category === 'Doors' || a >= 30 || b >= 30) {
    return raw / 144;
  }
  return raw;
};
